import  { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogActions, DialogContent, DialogContentText, useMediaQuery, TextField, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSelector, useDispatch } from "react-redux";
import * as action from '../../../actions/index.js';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CustomButton from '../CustomButton/CustomButton.js';
import { styled } from "@mui/system";
import {
  getRejectionReason
} from '../../../selectors/release-management-selector.js';
import { getLogoutChecked } from '../../../selectors/auth-config-selector.js';

const CustomDialogBox = styled(Dialog)({
  "& .MuiPaper-root": {
    width: "17.8125rem",
    textAlign: "center",
    paddingBottom: "0.4rem"
  },
  "& .MuiDialogContent-root ": {
    fontFamily: "Nunito Sans",
    fontSize: "0.875rem",
    fontWeight: "600",
    fontStyle: "normal",
    lineHeight: "1rem",
    color: "#000",
    padding: "0px 20px"
  }
});

const ConfirmationDialogBox = ({ message, handleConfirm, inputTextRequired, page }) => {
  const dispatch = useDispatch();
  const confirmationAlert = useSelector((state) => state.userManagementReducer.confimationAlert);
  const textInputValue = useSelector(getRejectionReason);
  const [disable, setDisable] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const logoutConfirmation = useSelector(getLogoutChecked);

  const handleCancel = () => {
      dispatch(action.setLogoutChecked(false));
      dispatch(action.setConfimationAlert(false));
  };

  const handleInputChange = (event) => {
    dispatch(action.setRejectionReason(event.target.value));
  };

  useEffect(() => {
    if (inputTextRequired && textInputValue === '') {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [textInputValue, inputTextRequired]);

  return (
    <CustomDialogBox
      open={((page === "logout")? logoutConfirmation : confirmationAlert)}
      onClose={handleCancel}
      fullScreen={fullScreen}
      maxWidth={false}
      sx={{
        '& .MuiDialog-paper': {
          width: inputTextRequired ? { xs: '80%', sm: '15%', md: '20%' } : { xs: '70%', sm: '20%' },
          maxWidth: 'none',
          margin: 'auto',
          maxHeight: '90vh',
          height: 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding:'1rem 1rem'
        },
        '& .MuiInputBase-root': {
          height: inputTextRequired ? { xs: '12vh', sm: '15vh', md: '17vh' } : { xs: '10vh', sm: '10vh' },
        }
      }}
      fullWidth
    >
      <DialogContent>
        <DialogContentText sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center",marginBottom:"0rem" }}>
          <WarningAmberIcon style={{ "color": '#CF2F32',  "fontSize":'2rem' }}/>
          <span style={{ "paddingTop": "0.5rem", "fontWeight":"600","fontSize":"0.875rem" }}>{message}</span>
        </DialogContentText>
        {inputTextRequired && 
        <TextField
          id="outlined-multiline-static"
          autoFocus
          required
          placeholder='Description'
          label="Reason"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={textInputValue}
          onChange={handleInputChange}
          sx={{
           '& .MuiInputBase-root': { fontSize: "12px",marginTop:"10px",paddingRight:"0rem" },
           '& .MuiInputLabel-root': {
        fontSize: '12px', fontFamily: "Nunito Sans", fontWeight: "400",
        '&.Mui-focused, &.MuiFormLabel-filled': {
            fontWeight: '400', top: "4px", fontSize: ' 14px',
            fontFamily: "Nunito Sans", marginTop:"8px"
        },
    },
          }}
        />
        }
      </DialogContent>
      <DialogActions sx={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "0px 0px", marginTop:"0.5rem" }}>
        <CustomButton handleClick={handleConfirm} label={inputTextRequired === true ? "Send" : "Yes"} buttonStyle="confirmbox-filled" disabled={disable} />
        <CustomButton handleClick={handleCancel} label="No" buttonStyle="confirmbox-white" disabled={false} />
      </DialogActions>
    </CustomDialogBox>
  );
}

ConfirmationDialogBox.propTypes = {
  message: PropTypes.string,
  handleConfirm: PropTypes.func.isRequired,
  inputTextRequired: PropTypes.bool,
  page: PropTypes.string
};

export default ConfirmationDialogBox;
